import { render } from "./addEditmanager.vue?vue&type=template&id=4aace716&scoped=true"
import script from "./addEditmanager.vue?vue&type=script&lang=js"
export * from "./addEditmanager.vue?vue&type=script&lang=js"

import "./addEditmanager.vue?vue&type=style&index=0&id=4aace716&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aace716"]])

export default __exports__